import { useEffect, useRef, useState } from "react";
import { WhatsNewDialog } from "@/components/aph/WhatsNewDialog";
import { useVault } from "@/context/VaultContext";
import { Sidebar } from "@/components/aph/Sidebar";
import { ChatWindow } from "@/components/aph/ChatWindow";
import { OrbitalMark } from "@/components/aph/OrbitalLock";
import { onBackButton, exitApp } from "@/lib/native";

function Empty() {
  return (
    <div className="flex-1 hidden md:flex flex-col items-center justify-center text-center px-10 starfield" data-testid="chat-empty-state">
      <OrbitalMark className="w-20 h-20 mb-6" />
      <h2 className="font-branding text-2xl font-semibold mb-2">Silent orbit</h2>
      <p className="text-sm text-ash/45 max-w-sm">Share your Aphelion ID or add a contact's ID to open an end-to-end encrypted channel. Nothing readable ever touches the relay.</p>
    </div>
  );
}

const inChat = () => !!window.history.state?.aphChat;

function useChatHistory(activeSid, setActiveSid) {
  const sidRef = useRef(activeSid);
  sidRef.current = activeSid;
  const openedRef = useRef(false);

  useEffect(() => {
    if (activeSid) {
      if (!inChat()) window.history.pushState({ ...window.history.state, aphChat: true }, "");
      openedRef.current = true;
    } else if (inChat()) {
      if (openedRef.current) window.history.back();
      else window.history.replaceState({ ...window.history.state, aphChat: false }, "");
    }
    if (!activeSid) openedRef.current = false;
  }, [activeSid]);

  useEffect(() => {
    const onPop = () => { if (!inChat()) setActiveSid(null); };
    window.addEventListener("popstate", onPop);
    const offBack = onBackButton(() => (sidRef.current ? setActiveSid(null) : exitApp()));
    return () => { window.removeEventListener("popstate", onPop); offBack(); };
  }, [setActiveSid]);
}

export default function ChatPage() {
  const { activeSid, setActiveSid } = useVault();
  const [newsOpen, setNewsOpen] = useState(false);
  useChatHistory(activeSid, setActiveSid);

  return (
    <div className="h-[100dvh] flex bg-void text-ash overflow-hidden pt-[env(safe-area-inset-top)]" data-testid="chat-page">
      <div className={`${activeSid ? "hidden md:flex" : "flex"} w-full md:w-[340px] flex-shrink-0`}><Sidebar /></div>
      {activeSid ? <ChatWindow key={activeSid} /> : <Empty />}
      <WhatsNewDialog open={newsOpen} onOpenChange={setNewsOpen} />
    </div>
  );
}
